<div class="form-field mb-3">
  @if (!!label()) {
    <label [for]="id()" class="form-label">{{ label() }} </label>
  }

  <textarea
    [id]="id()"
    [(ngModel)]="value"
    class="form-control"
    [disabled]="disabled"
    [placeholder]="placeholder()"
    [required]="isRequired"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-describedby]="ariaDescribedBy"
    [attr.aria-invalid]="
      control && control.touched && control.dirty && control.invalid
    "
    [class.is-invalid]="
      control && control.touched && control.dirty && control.invalid
    "
  >
  </textarea>

  <b2c-form-field-errors
    [id]="id() + '-errors'"
    [control]="control"
    [errorMessages]="errorMessages()"
    [serverErrorMessage]="serverErrorMessage()"
  />
</div>
